module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6700bbb3ddff3f5bd94ab24020f739da.png";